import BreakTextPage from '_modules/breakText/views/BreakTextPage.vue';
import Generates from './Root.vue';

export default {
  path: 'quebrar-texto',
  name: 'admin-break-text',
  component: Generates,
  redirect: '/novo',
  children: [
    {
      path: 'novo',
      name: 'admin-break-text-new',
      component: BreakTextPage,
    },
  ],
};
